module.exports = __webpack_public_path__ + "static/media/pen3.f13c3012.png";